<template lang="pug">
  .main(style="height: 100vh")
    el-row(style="height: 100vh")
      el-col.menu__container(:span="isMenuCollapsed ? 1 : 4")
        .menu__block
          el-menu.el-menu-vertical-demo.menu__list(default-active="0" :collapse="isMenuCollapsed" :collapse-transition="false")
            .menu-width-handler__container(@click="handleFullMenuStatus" :class="{ collapsed: isMenuCollapsed }")
              i.el-icon-caret-right(v-if="isMenuCollapsed")
              i.el-icon-caret-left(v-else)
            router-link(
              v-for="(menu, key) in availableMenus"
              :to="{name: menu.name}"
              :key="`menu-${menu.name}`"
              tag="div")
              el-menu-item(:index="`${key}`")
                i(:class="menu.icon")
                span(slot="title") {{ menu.title }}
            el-menu-item(:index="`${logoutIndex}`" @click="logout")
              i.el-icon-switch-button
              span Выйти
      el-col(:span="isMenuCollapsed ? 23 : 20" style="height: 100vh")
        .module-top__container
          .money__container
            .balance__container(v-if="balance.updated")
              i.el-icon-money.balance__icon
              .balance-amounts__container
                .balance-amount__container
                  span.balance__title Баланс:
                  span {{ `${balance.value} BTC` }}
                .balance-amount__container
                  span.balance__title Обновлен:
                  span {{ `${balance.updated}` }}
          .module__title {{ moduleTitle }}
          .exchange-info__container
            .exchange-wallet__container(v-if="wallet.updated" @click="copyTextToClipboard(wallet.value)")
              i.el-icon-copy-document
              .balance-amounts__container
                .balance-amount__container
                  span.balance__title Кошелек:
                  span {{ wallet.value }}
                .balance-amount__container
                  span.balance__title Обновлен:
                  span {{ wallet.updated }}
        router-view
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { CHANGE_RELOAD_STATUS } from '../../store/const/index';
  import { AUTH_LOGOUT } from '@/store/const/user';
  import { LOAD_EXCHANGE_INFO } from '@/store/const/settings';
  import instruments from '../../mixins/instruments';

  export default {
    name: "Index",
    mixins: [
        instruments,
    ],
    data() {
      return {
        menuList: [
          {
            name: 'OrdersList',
            title: 'Заявки',
            icon: 'el-icon-s-grid',
            access: ['superadmin', 'admin', 'support']
          },
          {
            name: 'ClaimsList',
            title: 'Претензии',
            icon: 'el-icon-s-release',
            access: ['superadmin', 'admin', 'support']
          },
          {
            name: 'UsersList',
            title: 'Пользователи',
            icon: 'el-icon-user',
            access: ['superadmin']
          },
          {
            name: 'Settings',
            title: 'Настройки',
            icon: 'el-icon-setting',
            access: ['superadmin']
          },
          {
            name: 'ExchangeSettings',
            title: 'Настройки обменки',
            icon: 'el-icon-set-up',
            access: ['superadmin', 'admin']
          },
          {
            name: 'Stats',
            title: 'Статистика',
            icon: 'el-icon-coin',
            access: ['superadmin']
          },
          {
            name: 'BlackListUsers',
            title: 'ЧС Клиенты',
            icon: 'el-icon-s-custom',
            access: ['superadmin', 'admin', 'support']
          },
          {
            name: 'BlackListRequisites',
            title: 'ЧС Реквизиты',
            icon: 'el-icon-s-finance',
            access: ['superadmin', 'admin', 'support']
          },
          {
            name: 'Service',
            title: 'Сервис',
            icon: 'el-icon-set-up',
            access: ['superadmin', 'admin']
          },
          {
            name: 'ActionsStats',
            title: 'Мониторинг активности',
            icon: 'el-icon-s-data',
            access: ['superadmin', 'admin']
          },
         ],
        intervalHandle: null,
        isMenuCollapsed: false,
      }
    },
    watch: {
      reload(reload) {
        if (reload) {
          this.changeReloadStatus({ status: false });
          this.$router.go();
        }
      }
    },
    async mounted() {
      if (this.isAdmin) {
        await this.loadExchangeInfo();
        this.startInterval();
      }
    },
    beforeDestroy() {
      clearInterval(this.intervalHandle);
    },
    computed: {
      ...mapGetters('user', {
        role: 'getRole',
        isAdmin: 'isAdmin',
      }),
      ...mapGetters('settings', ['balance', 'wallet']),
      ...mapGetters(['reload']),
      availableMenus() {
        return this.menuList.filter((menu) => menu.access.includes(this.role));
      },
      logoutIndex() {
        return this.availableMenus.length;
      },
      moduleTitle() {
        return this.$route.meta.title;
      }
    },
    methods: {
      ...mapActions({
        changeReloadStatus: CHANGE_RELOAD_STATUS,
      }),
      ...mapActions('user', {
        logoutRequest: AUTH_LOGOUT,
      }),
      ...mapActions('settings', {
        loadExchangeInfo: LOAD_EXCHANGE_INFO,
      }),
      async logout() {
        await this.logoutRequest();
      },
      startInterval(){
        this.intervalHandle = setInterval(() => this.loadExchangeInfo(), 10000);
      },
      handleFullMenuStatus() {
        this.isMenuCollapsed = !this.isMenuCollapsed;
      },
    }
  }
</script>

<style lang="scss">
	.main {
		text-align: left;
	}

  .menu__list {
    height: 100%;
  }

  .mode-select__container {
    padding: 10px 0;
    margin: auto;
    text-align: center;
    border-bottom: 1px solid #e6e6e6;
  }

  .mode-select__container .title {
    font-weight: 500;
    margin-bottom: 5px;
  }

  .module__main {
    overflow-y: hidden;
    height: calc(100% - 50px);
    display: flex;
    flex-direction: column;
  }

  .module__title {
    font-size: 20px;
    background-color: #efefef;
    text-shadow: 1px 1px 1px #cce0f1;
    color: #05447a;
    font-weight: bold;
    text-align: center;
  }

  .module-content__container {
    display: flex;
    flex-direction: column;
    padding: 5px;
    background-color: #e3e0e0;
    border-left: 1px solid #d1cece;
    border-top: 1px solid #d1cece;
    overflow-y: hidden;
    height: 100%;
  }

  .menu__container {
    display: flex;
    height: 100vh;
    flex-direction: column;
    background-color: #efefef;
    padding: 4px;
  }

  .menu__block {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFF;
    border-right: solid 1px #e6e6e6;
    justify-content: space-between;
  }

  .menu-width-handler__container {
    cursor: pointer;
    width: 100%;
    text-align: right;
  }

  .menu-width-handler__container.collapsed {
    text-align: center;
  }

  .menu-width-handler__container:hover {
    background-color: #f7f7f7;
  }

  .table__container {
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
  }

  .table-list__container {
    overflow-y: scroll;
    border-radius: 5px;
  }

  .table-pagination__container {
    margin-bottom: 5px;
    text-align: center;
  }

  .table-list__container .val {
    text-overflow: ellipsis;
    word-break: break-word;
  }

  .dialog-add__input {
    width: 100%;
    margin: 5px auto;
  }

  .color-success {
    color: #67C23A;
  }

  .background-success {
    background-color: #67C23A;
  }

  .color-warning {
    color: #E6A23C;
  }

  .background-warning {
    background-color: #E6A23C;
  }

  .color-danger {
    color: #F56C6C;
  }

  .background-danger {
    background-color: #F56C6C;
  }

  .color-info {
    color: #909399;
  }

  .background-info {
    background-color: #909399;
  }

  .color-primary {
    color: #909399;
  }

  .background-primary {
    background-color: #409EFF;
  }

  tr.row-success {
    background-color: #c4f8ae !important;
  }

  tr.row-danger {
    background-color: #fcbbbb !important;
  }

  .module-top__container {
    background-color: #efefef;
    padding: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
  }

  .balance__container {
    display: flex;
    align-items: center;
  }

  .balance-amounts__container {
    margin: auto 10px;
  }

  .balance-amount__container {
    display: flex;
  }

  .balance__icon {
    color: green;
    font-size: 16px;
  }

  .balance__title {
    margin-right: 5px;
    width: 60px;
  }

  .exchange-info__container {
    font-size: 12px;
    display: flex;
    flex-direction: column;
  }

  .exchange-wallet__container {
    display: flex;
    align-items: center;
  }

  .exchange-wallet__container:hover {
    color: #3c34b9;
    cursor: pointer;
  }

  .exchange-wallet {
    margin-left: 5px;
  }

  .money__container {
    display: flex;
    padding: 8px;
    font-size: 12px;
    background-color: #efefef;
  }

  .rate__container {
    padding-left: 10px;
    border-left: 1px solid #c9c9c9;
  }

  .mr5 {
    margin-right: 5px;
  }

  .ml5 {
    margin-left: 5px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .mb5 {
    margin-bottom: 5px;
  }

  .mr10 {
    margin-right: 10px;
  }

  .ml10 {
    margin-left: 10px;
  }

  .mt10 {
    margin-top: 10px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .hidden {
    display: none;
  }
</style>

